import { queryKeys } from './useQueryContact'
import { useFetchContact } from './useFetchContact'
import { useQueryClientUtils } from '../useQueryClientUtils'

const createPerson = () => {
  const { createPerson } = useFetchContact()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()
  const { invalidateRelationalCacheDataByType, cancelRelationalRequestsByType } = useQueryClientUtils()

  return useMutation({
    mutationFn: createPerson,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey, queryKeys.persons(variables).queryKey, queryKeys.personsInfinite(variables).queryKey])

      cancelRelationalRequestsByType('persons') // type is 'persons' in include
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey, queryKeys.persons(variables).queryKey, queryKeys.personsInfinite(variables).queryKey])

      invalidateRelationalCacheDataByType('persons') // type is 'persons' in include
    },
  })
}

const updatePerson = () => {
  const { updatePerson } = useFetchContact()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()
  const { invalidateRelationalCacheDataByType, cancelRelationalRequestsByType } = useQueryClientUtils()

  return useMutation({
    mutationFn: updatePerson,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey, queryKeys.persons(variables).queryKey, queryKeys.personsInfinite(variables).queryKey])

      cancelRelationalRequestsByType('persons') // type is 'persons' in include
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey, queryKeys.persons(variables).queryKey, queryKeys.personsInfinite(variables).queryKey])
      invalidateRelationalCacheDataByType('persons') // type is 'persons' in include
    },
  })
}

const deletePerson = () => {
  const { deletePerson } = useFetchContact()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()
  const { invalidateRelationalCacheDataByType, cancelRelationalRequestsByType } = useQueryClientUtils()

  return useMutation({
    mutationFn: deletePerson,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey, queryKeys.persons(variables).queryKey, queryKeys.personsInfinite(variables).queryKey])
      cancelRelationalRequestsByType('persons') // type is 'persons' in include
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey, queryKeys.persons(variables).queryKey, queryKeys.personsInfinite(variables).queryKey])
      invalidateRelationalCacheDataByType('persons') // type is 'persons' in include
    },
  })
}

const createCompany = () => {
  const { createCompany } = useFetchContact()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: createCompany,
    onMutate: (variables) => {
      cancelQueries([
        queryKeys.all(variables).queryKey,
        queryKeys.companies(variables).queryKey,
        queryKeys.companiesInfinite(variables).queryKey,
      ])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([
        queryKeys.all(variables).queryKey,
        queryKeys.companies(variables).queryKey,
        queryKeys.companiesInfinite(variables).queryKey,
      ])
    },
  })
}

const updateCompany = () => {
  const { updateCompany } = useFetchContact()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: updateCompany,
    onMutate: (variables) => {
      cancelQueries([
        queryKeys.all(variables).queryKey,
        queryKeys.companies(variables).queryKey,
        queryKeys.companiesInfinite(variables).queryKey,
      ])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([
        queryKeys.all(variables).queryKey,
        queryKeys.companies(variables).queryKey,
        queryKeys.companiesInfinite(variables).queryKey,
      ])
    },
  })
}

const deleteCompany = () => {
  const { deleteCompany } = useFetchContact()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: deleteCompany,
    onMutate: (variables) => {
      cancelQueries([
        queryKeys.all(variables).queryKey,
        queryKeys.companies(variables).queryKey,
        queryKeys.companiesInfinite(variables).queryKey,
      ])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([
        queryKeys.all(variables).queryKey,
        queryKeys.companies(variables).queryKey,
        queryKeys.companiesInfinite(variables).queryKey,
      ])
    },
  })
}
export const useMutationContact = {
  company: {
    create: createCompany,
    update: updateCompany,
    delete: deleteCompany,
  },
  person: {
    create: createPerson,
    update: updatePerson,
    delete: deletePerson,
  },
}
